var React = require('react');

function Cauldron (props) {
    return React.createElement("svg",props,[React.createElement("defs",{"key":0},React.createElement("style",null,".fa-secondary{opacity:.4}")),React.createElement("path",{"d":"M160 0a32 32 0 1 0 32 32 32 32 0 0 0-32-32zm112 32a48 48 0 1 0 48 48 48 48 0 0 0-48-48zM96 288a32 32 0 0 0 64 0V160H96z","className":"fa-secondary","key":1}),React.createElement("path",{"d":"M434 224h-19.79c21.4 38.52 33.79 81.28 33.79 121.6 0 39.08-11.82 70.65-32 95.53V488a24 24 0 0 1-48 0v-7.49C329.05 501.81 278.86 512 224 512s-105-10.19-144-31.49V488a24 24 0 0 1-48 0v-46.87C11.82 416.25 0 384.68 0 345.6c0-40.32 12.39-83.08 33.79-121.6H14c-7.73 0-14-5.37-14-12v-40c0-6.63 6.27-12 14-12h82v128a32 32 0 0 0 64 0V160h274c7.73 0 14 5.37 14 12v40c0 6.63-6.27 12-14 12z","className":"fa-primary","key":2})]);
}

Cauldron.defaultProps = {"viewBox":"0 0 448 512","className":"icon"};

module.exports = Cauldron;

Cauldron.default = Cauldron;
